// Shared client-side fee math — the single source for every fee preview
// (Edit Ticket modal, onboarding fee line), so displayed numbers can never
// drift from each other or from the server.
//
// `consts` must come from ERB data attributes sourcing
// config/initializers/constants.rb (see organizer/tickets/_form.html.erb):
//   { stubFeePercent, stubFeeDollar, stripeFeePercent, stripeFeeCents }
// Deliberately NO numeric defaults here — a silently-defaulted rate that
// disagrees with the server is exactly the bug this file replaces.

// Platform (Stubs) fee — mirrors Ticket#calculate_platform_fee: 0 when the
// base is 0, otherwise percentage + flat dollar.
export function platformFee(base, consts) {
  if (!(base > 0)) return 0;
  return base * consts.stubFeePercent + consts.stubFeeDollar;
}

// Buyer-Pays total — exact mirror of Ticket#all_in_price: the charge is
// GROSSED UP so that after Stripe takes its percentage + fixed cut of the
// larger charge, the organizer still nets `base`. (A flat 2.9% + $0.30 on top
// of `base` understates the real checkout total — the $850.23-vs-$850.98 bug.)
export function allInPrice(base, consts) {
  if (!(base > 0)) return 0;
  const withPlatform = base + platformFee(base, consts);
  const grossedUp = (withPlatform + consts.stripeFeeCents) / (1 - consts.stripeFeePercent);
  return Math.round(grossedUp * 100) / 100;
}

// You-Pay net payout — buyer pays exactly `base`; Stripe deducts its real flat
// fee from that charge and the platform fee is still booked even when absorbed
// (PaymentGatewayService#application_fee_cents). The FLAT shape is correct in
// this direction — only the buyer-facing total grosses up.
//
// Computed in cents and rounded half-up ONCE (never toFixed on floats):
// Stripe rounds its own fee, so this is an estimate — copy should say "about".
export function netPayout(base, consts) {
  if (!(base > 0)) return 0;
  const cents = Math.round(base * 100);
  const stripeCents = cents * consts.stripeFeePercent + consts.stripeFeeCents * 100;
  const platformCents = cents * consts.stubFeePercent + consts.stubFeeDollar * 100;
  return Math.round(cents - stripeCents - platformCents) / 100;
}
